import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";
import {Calendar} from "primereact/calendar";
import {RadioButton} from "primereact/radiobutton";
import {price} from "../../../../utils/formatters/Numbers";
import {calculateAmount, calculateReward} from "../../../../utils/calculate/Amount";
import InstitutionDropDown from "../../../../components/dropDown/institution";
import InstrumentDropDown from "../../../../components/dropDown/instrument";
import AccountDropDown from "../../../../components/dropDown/account";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InputText} from "primereact/inputtext";
import {dateDDMMYY} from "../../../../utils/formatters/Date";
import {CALENDAR_ES} from "../../../../utils/constants/Constants";
import PropTypes from 'prop-types';


const InsertOrderTradeAdmin = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Operación \ Posturas Administrativas \ Insertar Postura"/>
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{textAlign: 'right'}}>
                            <Button
                                label="Cancelar"
                                className="p-button-secondary"
                                onClick={props.handleCancel}/>&nbsp;
                            <Button
                                label="Guardar"
                                disabled={props.isLoading}
                                onClick={props.insertOrderTradeAdmin}
                                tabIndex={9}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Prestamista" isBold={true}/>
                                <InstitutionDropDown
                                    name="catInstitutionLender"
                                    filter="nombreCorto"
                                    save={props.saveDataOrderTrade}
                                    value={props.orderTrade.catInstitutionLender}
                                    loading={props.loading}
                                    tabIndex={1}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Prestatario" isBold={true}/>
                                <InstitutionDropDown
                                    name="catInstitutionBorrower"
                                    filter="nombreCorto"
                                    save={props.saveDataOrderTrade}
                                    value={props.orderTrade.catInstitutionBorrower}
                                    loading={props.loading}
                                    tabIndex={2}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Cuenta" isBold={true}/>
                                <AccountDropDown
                                    ref={props.accountDropDown}
                                    name="catAccount"
                                    filter="cuenta"
                                    save={props.saveDataOrderTrade}
                                    value={props.orderTrade.catAccount}
                                    sessionAccount={false}
                                    loading={props.loading}
                                    disabled={props.readOnlyLenderAccount}
                                    tabIndex={3}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Emisora" isBold={true}/>
                                <InstrumentDropDown
                                    name="catInstrument"
                                    filter="emisoraSerieCupon"
                                    save={props.saveDataOrderTrade}
                                    value={props.orderTrade.catInstrument}
                                    loading={props.loading}
                                    tabIndex={4}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Títulos" isBold={true}/>
                                <NumberFormat
                                    name="cantidad"
                                    autoComplete='none'
                                    value={props.orderTrade.cantidad}
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={0}
                                    maxLength={17}
                                    onChange={props.saveDataOrderTrade}
                                    placeholder="Ex: 99,99"
                                    customInput={InputText}
                                    tabIndex={5}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Tasa" isBold={true}/>
                                <NumberFormat
                                    name="tasa"
                                    autoComplete='none'
                                    value={props.orderTrade.tasa}
                                    allowNegative={false}
                                    decimalScale={2} id={9} maxLength={12}
                                    onChange={props.saveDataOrderTrade}
                                    placeholder="Ex: 99,99"
                                    customInput={InputText}
                                    tabIndex={6}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Sobretasa" isBold={true}/>
                                <NumberFormat
                                    name="sobreTasa"
                                    value={props.orderTrade.sobreTasa}
                                    decimalScale={2} id={9} maxLength={12}
                                    onChange={props.saveDataOrderTrade}
                                    placeholder="Ex: 99,99"
                                    customInput={InputText}
                                    tabIndex={8}
                                    allowNegative={false}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Plazo" isBold={true}/>
                                <NumberFormat
                                    name="plazo"
                                    autoComplete='none'
                                    value={props.orderTrade.plazo}
                                    onChange={props.saveDataOrderTrade}
                                    tabIndex={7}
                                    maxLength={4}
                                    decimalScale={0}
                                    allowNegative={false}
                                    fixedDecimalScale={false}
                                    placeholder="Ex: 99,99"
                                    customInput={InputText}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Fecha Vence" isBold={true}/>
                                <Typography variant="subtitle2" gutterBottom
                                            style={props.orderTrade.validDate ? {} : {color: "red"}}>
                                    {dateDDMMYY(props.orderTrade.fechaVence)}
                                </Typography>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Fecha Valor" isBold={true}/>
                                <Calendar
                                    name="fecValor"
                                    dateFormat={"dd/mm/yy"}
                                    value={props.orderTrade.fecValor}
                                    disabledDays={[0, 6]}
                                    readonlyInput={true}
                                    onChange={props.saveDataOrderTrade}
                                    minDate={props.today}
                                    maxDate={props.maxValueDate}
                                    monthNavigator={true}
                                    yearNavigator={true}
                                    yearRange={CALENDAR_ES['yearRange']}
                                    locale={CALENDAR_ES}
                                    showButtonBar={true}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Precio" isBold={true}/>
                                <SubtitleLabel header={price(props.orderTrade.precio)} />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Importe" isBold={true}/>
                                <SubtitleLabel header={calculateAmount(props.orderTrade.precio, props.orderTrade.cantidad)}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Premio" isBold={true}/>
                                <SubtitleLabel header= {
                                    calculateReward(
                                        props.orderTrade.cantidad,
                                        props.orderTrade.precio,
                                        props.orderTrade.tasa,
                                        props.orderTrade.plazo,)} />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <SubtitleLabel header="Vigencia" isBold={true}/>
                                <Typography variant="subtitle2" gutterBottom>
                                    <RadioButton
                                        inputId="today"
                                        name="orderType"
                                        value="today"
                                        checked={props.orderTrade.orderType === 'today'}
                                        onChange={props.saveDataOrderTrade}
                                        disabled={props.orderTrade.disabledRadio}/>
                                    <label htmlFor="today" className="p-radiobutton-label secondary-text">Diaria</label>
                                    &nbsp;
                                    <RadioButton
                                        inputId="week"
                                        name="orderType"
                                        value="week"
                                        checked={props.orderTrade.orderType === 'week'}
                                        onChange={props.saveDataOrderTrade}
                                        disabled={props.orderTrade.disabledRadio}/>
                                    <label htmlFor="week" className="p-radiobutton-label secondary-text">Semanal</label>
                                </Typography>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

InsertOrderTradeAdmin.propTypes = {
    isLoading: PropTypes.bool.isRequired
};

export default InsertOrderTradeAdmin;